import {Component, Inject, OnDestroy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {Subscription} from 'rxjs';

import {
    ApiError,
    UsersService,
    CompanyEmployeesService,
    IndividualSubordinatesService,
    CompanyExtendedModel,
    CountryModel,
    IndividualExtendedModel
} from '@spa/api';

import {FormComponent} from '../../../../shared/widgets';
import {FormInterface} from '../../../../shared/interfaces';
import {DialogActionsEnum, DialogComponent, DialogConfigInterface} from '../../../../shared/components';

import {AddUserToClientForm} from '../../forms';
import {AddUserToClientMessages} from '../../../../../assets/messages';
import {AddUserToClientFormErrorStatesEnum} from '../../enums/error-states';

@Component({
    selector: 'app-add-user-to-client',
    templateUrl: './add-user-to-client.component.html',
    styleUrls: ['./add-user-to-client.component.scss']
})
export class AddUserToClientComponent extends DialogComponent<AddUserToClientComponent> implements FormInterface, OnDestroy {
    private registerClientSubscription: Subscription;

    public addUserToClientForm: AddUserToClientForm;

    constructor(
        private usersService: UsersService,
        private companyEmployeesService: CompanyEmployeesService,
        private individualSubordinatesService: IndividualSubordinatesService,
        @Inject(MAT_DIALOG_DATA) public data: {
            client: IndividualExtendedModel | CompanyExtendedModel,
            countries: CountryModel[],
            config: DialogConfigInterface,
            isCorporateClient: boolean
        },
        public dialogRef: MatDialogRef<AddUserToClientComponent>
    ) {
        super(dialogRef);

        this.config = data.config;

        this.initForm();
    }

    ngOnDestroy(): void {
        if (this.registerClientSubscription) {
            this.registerClientSubscription.unsubscribe();
        }
    }

    getFormMessages(controlLabel?: string, controlMaxLength?: number): { [p: string]: string } {
        return FormComponent.getFormMessages(controlLabel, controlMaxLength);
    }

    initForm(): void {
        this.addUserToClientForm = new AddUserToClientForm(
            this.data.client,
            this.data.countries,
            this.data.isCorporateClient,
            this.companyEmployeesService,
            this.individualSubordinatesService,
            this.usersService
        );

        this.addUserToClientForm.initForm();
    }

    validateForm(): boolean {
        return this.addUserToClientForm.validateForm(this.getFormMessages);
    }

    onFormSubmit(action?: number): void {
        switch (action) {
            case DialogActionsEnum.ProcessFinished:
                this.dialogRef.close(!this.config.process.failed);
                break;
            case DialogActionsEnum.Confirm:
                if (this.validateForm()) {
                    this.startLoading(() => {
                        this.registerClientSubscription = this.addUserToClientForm
                            .createRequest()
                            .subscribe(this.dialogSubscribeHandler.bind(
                                this,
                                null,
                                (errors: ApiError[]) => {
                                    this.config.process.failedMessage = errors.map((error: ApiError) => {
                                        if (error.status === AddUserToClientFormErrorStatesEnum.RegisterFailed) {
                                            return AddUserToClientMessages.RegisterClientUserFailed.message;
                                        }

                                        return AddUserToClientMessages.UnknownError.message;
                                    }).join('</br>');
                                })
                            );
                    });
                }
                break;
            default:
                this.dialogRef.close(false);
        }
    }
}
